// useAgentChatGate — gate de la feature del chat de soporte Paulina (AGENT_CHAT_FEATURE_KEY),
// instancia del contrato `FeatureGate` (ver useFeatureGate.ts). Una sola definición; todas las
// superficies que decidan montar/ofrecer Paulina consumen este hook.
//
//   - `offered`: el comercio TIENE Paulina (treatment o GA con flag de build) → se monta el chat.
//     El build-flag 'agent-chat' está ON en TODOS los ambientes (desde 65003106, 2026-06-16) y el
//     rollout 'agent-chat-rollout-2026q2' está al 100% (GA) → `offered` es true para todos, así que
//     el PaulinaGate de Layout monta Paulina para TODOS los comercios. El único gate que aún silencia
//     algo es la proactividad/nudges (PAULINA_NUDGES_ENABLED en usePaulinaChat), no el montaje.

import { makeFeatureGateHook } from '@hooks/useFeatureGate';
import { AGENT_CHAT_FEATURE_KEY } from '@utils/featureRollout/constants';

export const useAgentChatGate = makeFeatureGateHook({
  featureKey: AGENT_CHAT_FEATURE_KEY,
  inviteTrigger: 'agent_chat',
});
